/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 08 2024
 **/

import OneOnOneBlock from "./OneOnOneBlock";
import GroupBlock from "./GroupBlock";
import { Configure } from "@/frameworks/libraries/utilities";
import { usePersistActions } from "@/frameworks/core/persistence";

export default function BlockInfoPopup({
	userIDs,
	type,
	variant
}: {
	userIDs: string[];
	type: "Space" | "DM" | "CONFERENCE";
	variant: ChatUI.Size;
}) {
	const { users } = usePersistActions();

	const blockedUserList = userIDs
		.map((id) => users.get_user(id))
		.filter(Boolean)
		.filter((v) => Boolean(v?.blockedByMe));
	const isOneOnOne = userIDs.filter((userID) => userID !== Configure.userID).length === 1;
	const hasBlockedUser = blockedUserList.length > 0;

	if (!hasBlockedUser) return;
	if (isOneOnOne && type === "DM") return <OneOnOneBlock blockedUser={blockedUserList[0] as Users.People.Data} />;
	return <GroupBlock blockedUserList={blockedUserList as Users.People.Data[]} variant={variant} />;
}
